import { useContext } from "react";

import type { IMainTourContext } from "@/contexts/MainTourContext";
import { MainTourContext } from "@/contexts/MainTourContext";

export const useMainTour = (): IMainTourContext => {
  const context = useContext(MainTourContext);

  // NOTE: this guard ensures the hook is used within its required provider and does not need test coverage.
  /* istanbul ignore next */
  if (context === null) {
    throw new Error("useMainTour must be used within a MainTourProvider");
  }
  return context;
};
